module.exports = __webpack_public_path__ + "img/repguide-wartung-screenshots-intervalle.ad5ad6df.jpg";